export default __webpack_public_path__ + "static/media/defaultBanner.11be2b6e.svg";